/* Toiles Glatz — données v2026-10-22 (Supabase matieres + collection parasols-glatz + PDF Glatz 2026 / plis-traces 2025).
   Régénérer à la main quand le nuancier ou les fiches changent (doc projet claude/chantier-toiles-glatz.md).
   Modèles : handle|nom. Toiles : code|nom|qualité|hex|familles|drapeaux (m rayures, q Quickship, h hors nuancier 2026, z photo cadrée trop large → on affiche le centre à taille réelle)|plis+traces (0 faible, 1 moyen, 2 fort ; vide = pas de données)|palette|modèles (index, q = Quickship) */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0360/3251/2135/files/';
  var M = `glatz-parasol-alu-smart|ALU-SMART
glatz-parasol-alu-twist-easy|ALU-TWIST
glatz-parasol-sunwing-casa|SUNWING® Casa
glatz-parasol-twist|TWIST
glatz-parasol-smart|SMART
glatz-parasol-sombrano-s-easy|SOMBRANO® S+
glatz-parasol-alexo|ALEXO®
glatz-parasol-fortano|FORTANO®
glatz-parasol-vita-piana|VITA® Piana
glatz-parasol-vita®-sfera|VITA® Sfera
glatz-parasol-vita®-torna|VITA® Torna
glatz-parasol-fortero®-pro|FORTERO® Pro
glatz-parasol-piazza®|PIAZZA®
glatz-parasol-teakwood|TEAKWOOD
glatz-ambiente-nova-parasol-professionnel|AMBIENTE Nova
glatz-palazzo-royal-parasol-geant-professionnel|PALAZZO® Royal
glatz-castello-pro-parasol-professionnel|CASTELLO® Pro
glatz-palazzo-noblesse-parasol-professionnel|PALAZZO® Noblesse
glatz-palazzo-style-parasol-professionnel|PALAZZO® Style
glatz-parasol-pendalex-p|PENDALEX® P+
glatz-parasol-fortello-led|FORTELLO® LED`;
  var T = `500|Plaster|5|E8E9E4|blanc gris||00|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
501|Granite|5|999999|gris|q|00|ml|6,0,1,14,16,7,20,11,17,15,18,19,12,5q,2q,13,8,9,10
502|Thunder|5|575653|gris anthracite|q|00|ml|6,0,1,14,16,7,20,17,15,18,19,12,5q,2q,13,8,9,10
509|Slate|5|75787B|gris||02|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
510|White|5|EEF0E8|blanc||20|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
513|Outback|5|932930|rouge brun||00|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
514|Corn|5|F5AB32|jaune||11|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
515|Cloud|5|6A94B5|bleu||00|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
521|Aloe|5|244434|vert||01|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
523|Champagne|5|EAE2D5|beige-sable blanc|q|22|ml|6,0,1,14,16,7q,20q,11,17,15,18,19q,12,5q,2q,13,8,9,10
526|Bamboo|5|BEAC84|beige-sable||00|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
527|Urban Chrome|5|9B9A97|gris||00|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
530|Atlantic|5|253145|bleu||02|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
550|Cement|5|D0D3D4|gris beton-pierre||01|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
555|Grey Stripe|5|A2AAAD|gris multicolore-motif|m|21|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
556|Alabaster|5|C7C9C7|blanc gris beige-sable|q|21|ml|6,0,1,14,16,7,20,17,15,18,19,12,5q,2,13,8,9,10
558|Steel|5|A59C94|gris||12|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
570|Steel Stripe|5|A59C94|gris multicolore-motif|m|22|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
579|Pistachio|5|9CAF88|vert||11|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
581|Jade|5|94A596|vert gris||22|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
588|Olive|5|708573|vert gris||02|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
589|Green Stripe|5|00594C|vert multicolore-motif|m|10|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
600|Wave|5|236192|bleu||02|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
601|Waterfall|5|5B7F95|bleu gris||12|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
602|Blue Stripe|5|151F6D|bleu multicolore-motif|m|20|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
603|Horizon|5|768692|bleu gris||11|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
604|Cereal|5|D29F13|jaune||01|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
605|Clay|5|A29F91|gris brun||10|sg|6,0,1,14,16,7,20,11,17,15,18,19,12,5,2,13,8,9,10
611|Sandstone|5|827C70|brun gris||02|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
615|Black|5|27201A|noir||00|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
617|Safran|5|F1BE48|jaune||21|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
618|Dijon|5|9F7D23|jaune orange||11|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
624|Yellow Stripe|5|F1BE48|jaune multicolore-motif|m|20|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
637|Cherry|5|9B2743|rouge violet||00|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
639|Blush|5|CA9A8E|rose||12|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
644|Merlot|5|874B52|rouge brun||10|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
645|Burgundy|5|550528|rouge violet||01|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
646|Rubino|5|9C0F1E|rouge||01|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
650|Camel|5|AA9B88|beige-sable brun||02|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
652|Silver|5|A3A09F|gris||02|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
657|Sky|5|8CA8CD|bleu|h|||6
660|Papaya|5|CC5D42|orange rouge||10|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
665|Chrome|5|C1C7C7|gris||22|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
669|Carbone|5|4D4D4B|anthracite||01|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
677|Nile|5|5F7756|vert||02|ml|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
684|Urban Shadow|5|8A8D8C|gris|z|00|ml|6,0,1,14,16,7,20,11,17,15,18,19,12,5,2,13,8,9,10
686|Urban Clay|5|B8B2AB|gris beige-sable|qz|00|ml|6,0,1,14,16,7,20,11,17,15,18,19,12,5q,2q,13,8,9,10
800|Red Stripe|5|9D2235|rouge multicolore-motif|m|00|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
801|Campari|5|A6192E|rouge||01|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
802|Sienna|5|DB864E|orange||11|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
803|Linen|5|C5B9AC|beige-sable|q|11|sg|6,0,1,14,16,7,20,17,15,18,19,12,5q,2q,13,8,9,10
805|Walnut|5|7A6855|brun||00|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
806|Forge|5|707372|gris||02|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
807|Lava|5|63666A|gris anthracite||00|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
809|Midnight|5|3D3935|noir anthracite||00|sg|6,0,1,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
810|Black Stripe|5|3D3935|noir multicolore-motif|m|00|sg|6,0,14,16,7,20,17,15,18,19,12,5,2,13,8,9,10
403|Carmine|4|A53430|rouge||||6,0,1,7,20,11,12,2,13,3
404|White|4|F4F3EB|blanc|q|||6,0q,1q,7,20,12,4,13,3
408|Black|4|2F2A26|noir||||6,0,1,7,20,12,13
416|Caribbean|4|009C9B|bleu vert|h|||0
417|Ocean|4|7F9C90|vert bleu|q|||6,0q,1q,7,20,12,4,13
418|Cobalt|4|326295|bleu||||6,0,1,7,20,12,13
420|Smoke|4|959697|gris|q|||6,0q,1q,7q,20,11,12,4,5q,2q,13,3
422|Cream|4|CDC7B7|beige-sable|q|||6,0q,1q,7,20,11,12,4,5q,2q,13,3
436|Wine|4|6C333A|rouge violet||||6,0,1,7,20,12,13
438|Straw|4|F6C87D|jaune||||6,0,1,7,20,12,13
453|Vanilla|4|E6DDD8|blanc beige-sable|q|||6q,0q,1q,7q,20q,11,12q,4,5q,2q,13,3
461|Taupe|4|9C998B|brun gris|q|||6,0q,1q,7,20,11,12,4,5q,2q,13,3
150|Eggshell|2|DED4C0|beige-sable blanc|h|||5
151|Ash|2|ABA8A1|gris|q|||0q,1q,2q
156|Pale Grey|2|B2B4B2|gris|q|||0q,1q
157|Stone Grey|2|5B5B5B|gris anthracite|q|||0q,1q,5q,2q
158|Off White|2|D6D2C4|blanc beige-sable|q|||0q,1q,20q,11,12q,5q,2q`;
  var models = M.split('\n').map(function (l) { var a = l.split('|'); return { h: a[0], t: a[1] }; });
  var toiles = T.split('\n').map(function (l) {
    var a = l.split('|'), f = a[5], b = 'glatz_toile_q' + a[2] + '_' + a[0] + '_' + a[1].toLowerCase().replace(/ /g, '-') + '.jpg';
    return { c: a[0], n: a[1], q: a[2], x: '#' + a[3], f: a[4].split(' '), m: f.indexOf('m') >= 0, qs: f.indexOf('q') >= 0, h: f.indexOf('h') >= 0, z: f.indexOf('z') >= 0,
      s: a[6] ? [+a[6][0], +a[6][1]] : null, p: a[7], i: CDN + 'mat_' + b, v: CDN + 'mat-vg_' + b,
      md: a[8] ? a[8].split(',').map(function (x) { return [parseInt(x, 10), /q$/.test(x) ? 1 : 0]; }) : [] };
  });
  window.TGZ_DATA = { v: '2026-10-22', models: models, toiles: toiles };
})();
